import { ReactNode } from 'react';

import { dateFormatter, useSingleInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';
import { appendTestableElementAttributes, StyledFlex, TestableComponentProps } from '@dreryk/react-components';

export type MedicalTreatmentConsentPanelProps = {
   readonly labelKey: string;
   readonly date: Date;
   readonly children: ReactNode;
} & TestableComponentProps;

const MedicalTreatmentConsentPanel = (props: MedicalTreatmentConsentPanelProps): JSX.Element => {
   const translate = useTranslate();
   const label = useSingleInterpolatedTranslationKey(props.labelKey, 'date', dateFormatter(props.date));

   return (
      <StyledFlex gap={24}>
         <label {...appendTestableElementAttributes(props.testId)}>{translate(label)}</label>
         {props.children}
      </StyledFlex>
   );
};

export { MedicalTreatmentConsentPanel };
